import axios from "axios";
import { getAuthToken } from "@/utils/session";

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASEURL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      // Only set country if not already provided in request
      if (!config.headers["country"]) {
        const isIndia = window.location.pathname.startsWith("/in");
        const countryCode = isIndia ? "IN" : "UAE";
        config.headers["country"] = countryCode;
      }

      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
